import React from 'react';
import PropTypes from 'prop-types';
import { formatNumber, getUserName } from 'helpers';

const AssociatedPilgrimsList = ({ trips = [], fallbackCount = 0, invoiceCode, scrollAfterSixRows = false }) => {
  if (!trips?.length) {
    return <p className="py-2 text-sm italic text-gray-500">{fallbackCount} dépôt(s) associé(s)</p>;
  }

  return (
    <div className="w-full max-w-[730px] text-sm" role="table" aria-label={`Pèlerins de ${invoiceCode}`}>
      <div
        className="grid grid-cols-[minmax(0,1fr)_minmax(100px,150px)] border-b border-[#e3e6e4] pb-1 text-[#747b76] sm:grid-cols-[minmax(0,1fr)_190px]"
        role="row"
      >
        <span role="columnheader">Pèlerin</span>
        <span role="columnheader" className="text-right">
          Montant payé
        </span>
      </div>
      <div
        className={
          scrollAfterSixRows && trips.length > 6
            ? 'max-h-60 overflow-y-auto overscroll-contain outline-none focus-visible:ring-2 focus-visible:ring-hajj-primary/30 [scrollbar-color:#c9d3cc_transparent] [scrollbar-gutter:stable] [scrollbar-width:thin]'
            : undefined
        }
        tabIndex={scrollAfterSixRows && trips.length > 6 ? 0 : undefined}
        role="rowgroup"
      >
        {trips.map((trip, index) => (
          <div
            key={trip.id || `${trip.first_name}-${trip.last_name}-${index}`}
            className="grid min-h-10 grid-cols-[minmax(0,1fr)_minmax(100px,150px)] items-center border-b last:border-0 sm:grid-cols-[minmax(0,1fr)_190px]"
            role="row"
          >
            <div className="pr-4 text-left" role="cell">
              <span className="block font-medium text-gray-900">{getUserName(trip.first_name, trip.last_name)}</span>
              {trip.npi && <span className="mt-0.5 block text-xs text-gray-500">NPI {trip.npi}</span>}
            </div>
            <div className="text-right font-medium tabular-nums text-[#424c45]" role="cell">
              {`${formatNumber(trip.amount)} F CFA`}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

AssociatedPilgrimsList.propTypes = {
  trips: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      npi: PropTypes.string,
      amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ),
  fallbackCount: PropTypes.number,
  invoiceCode: PropTypes.string.isRequired,
  scrollAfterSixRows: PropTypes.bool,
};

export default AssociatedPilgrimsList;
